import  { CARGAR_CUENTASBANCARIAS } from './actionTypes';
import global_axios from '../../funciones_globales/interaccionapi';
import { VISUALIZAR_ALERTA } from '../generales/actionTypes';

export const cargar_CuentasBancarias = (tipoCuenta='') => {
	let url = '/cuentasbancarias';
	if(tipoCuenta !== ''){
		url += `?TipoCuenta=${tipoCuenta}`;
	}
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url
		}
		return global_axios(config_request)
		.then( response => {
			let ctasBancarias = response.data;
			dispatch({
				type: CARGAR_CUENTASBANCARIAS,
				data: ctasBancarias
			})
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;			
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar cuentas bancarias', mensaje: msgError}
			});
		});

	}
}